export default "__VITE_ASSET__948d8978__"